<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container fluid>
            <v-form ref="searchCadForm" @submit="search" onSubmit="return false">
                <v-card flat>
                    <v-card-actions>
                        <v-btn outlined color="info" @click="addConfiguration()">
                            Create Configuration
                            <v-icon right dark>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-data-table :headers="headers"
                          :items="configs"
                          class="elevation-1"
                          :options.sync="pagination"
                          :loading="loading"
                          :server-items-length="totalRecords">
                <template v-slot:item.actions="{item}">
                    <v-btn icon v-on:click="editConfiguration(item.id)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>
    import api from '@/api'

    export default {
        name: "CadConfigurations",
        data() {
            return {
                headers : [
                    {text:'Description',value:'description'},
                    {text:'Tenant',value:'tenant'},
                    {text:'Actions',value:'actions'},
                ],
                totalRecords : null,
                configs : [],
                pagination: {
                    rowsPerPage : 25,
                    pageNumber  : 0
                },
                loading:false,
                filter : {
                    name : null
                }
            };
        },
        watch: {
            pagination: {
                handler () {
                    this.search()
                },
                deep: true
            }
        },
        methods: {
            addConfiguration() {
                this.$router.push({'path':'/cad/create'});
            },
            editConfiguration(id) {
                this.$router.push({'path':'/cad/'+id});
            },
            resetFilter: function () {
                this.filter = {};
                this.performOrganizationSearch();
            },
            search() {
                const sortDesc = !!this.pagination.sortDesc[0];
                const sortOrder = sortDesc ? 'DESC' : 'ASC';
                const that = this;
                that.loading = true;
                api.cadConfig.search({
                    pageNumber: this.pagination.page - 1,
                    rowsPerPage: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortOrder: sortOrder,
                    name : this.filter.name
                }).then((data) => {
                    this.configs = data.list;
                    this.totalRecords = data.totalRecords;
                }).finally(() => {
                    that.loading = false;
                });
            }
        }
    }

</script>
